<template>
  <!-- 背调异常审批流程 -->
  <div class="detail">
    <ax-panel  title="基本信息">
      <van-cell
        title="候选人编号"
        :value="data.header.emplid"
      ></van-cell>
      <van-cell
        title="候选人姓名"
        :value="data.header.name_display"
      ></van-cell>
      <van-cell
        title="背调结果"
        :value="data.header.qh_backg_judge_description"
      ></van-cell>
      <van-cell
        title="业务类型"
        :value="data.header.business_unit_description"
      ></van-cell>
      <van-cell
        title="职位"
        :value="data.header.posn_descr"
      ></van-cell>
      <van-cell
        title="管理层级"
        :value="data.header.qh_jobmanage_level_description"
      ></van-cell>
      <van-cell
        title="专业层级"
        :value="data.header.qh_major_level_description"
      ></van-cell>
      <van-cell
        title="所属部门"
        :value="data.header.deptid_description"
      ></van-cell>
      <van-cell
        title="工作地点"
        :value="data.header.location_description"
      ></van-cell>
      <van-cell
        title="公司"
        :value="data.header.company_description"
      ></van-cell>
      <p class="remarks">判灯详情请点击背调报告或登录pc端审批界面查看。【PC端路径：EHR人力资源系统首页-我的待办】</p>
    </ax-panel>
    <!-- 业务意见 -->
    <ax-panel title="背景调查">
        <div class="setpic" v-if="ispic" >
          <div class="guanbi">
            <img :src="require('../../assets/img/guanbi.png')" class="guanbiimg" @click="closeImg" />
            <img :src="imgSrc" class="pic" />
          </div>
         
        </div>
        <!-- <div class="setpic" v-if="isfie">
        <div class="fleguanbi">
            <img :src="require('../../assets/img/guanbi.png')" class="guanbiimg" @click="closefie" />
          </div>
          <div id="pdfContainer" style="width: 100%;height: 800px; overflow: auto;"></div>
        </div> -->
        <ul class="fileList">
          <li v-for="(itme,index) in data.qh_hr_029_hd01" :key="index" >
              <div>
                <img v-if="getMatch(itme.filename)==='pdf'||getMatch(itme.filename)==='PDF'" :src="require('../../assets/img/pdf.png')" />
                <img v-if="getMatch(itme.filename)==='doc' || getMatch(itme.filename)==='docx'" :src="require('../../assets/img/doc.png')" />
                <img v-if="getMatch(itme.filename)==='jpg'||getMatch(itme.filename)==='jpeg' ||getMatch(itme.filename)==='png'||getMatch(itme.filename)==='gif'"  :src="require('../../assets/img/pic.png')" />
                <div>
                  <p>
                    {{itme.filename}}
                  </p>
                  <p>{{itme.size}}</p>
                </div>
              </div>
              <div class="downloads" @click="downloads(itme,$event)" v-if="getMatch(itme.filename)==='pdf' ||getMatch(itme.filename)==='PDF'|| getMatch(itme.filename)==='doc' || getMatch(itme.filename)==='docx'|| getMatch(itme.filename)==='pptx'" >
                  下载
              </div>
              <div class="downloads" @click="downloads(itme,$event)" v-else >
                  预览
              </div>
          </li>
        </ul>
    </ax-panel>
     <!-- 面试信息 -->
    <ax-panel title="面试信息">
        <div class="InterviewInformation">
          <ul>
            <li class="titles">
               <span>面试</span>
               <span>面试姓名</span>
               <span>面试结论</span>
             </li>
             <li v-for="itme in data.qh_hr_029_hd03">
                <span>{{itme.qh_interview_seqno_description}}</span>
                <span>{{itme.emplid2_description}}</span>
                <span>{{itme.qh_interview_r_description}}</span>
             </li>
          </ul>
        </div>
        <p class="tips">附件信息请到PC端查看，或联系招聘负责人获取</p>
    </ax-panel>
     <!-- 审批意见 -->
     <ax-panel title="聘用HR审批意见">
      <div class="view">
          <p>
            <!-- 意见的本意是人们对事物所产生的看法或想法。
            意见是上级领导机关对下属机关部署工作，指导下级机关工作活动的原则，步骤 -->
            {{data.header.comments}}
          </p>
      </div>
    </ax-panel>
    <!-- <van-cell
        title="聘用HR审批意见"
        :value="data.header.comments"
      ></van-cell> -->
  </div>
</template>

<script>
import moment from 'moment';
import request from '@/utils/request';
import CryptoJS from 'crypto-js';
import watermark from '../../utils/warterMark';
// import { saveAs } from 'file-saver';
//修改引用不报错
// import * as pdfjsLib from 'pdfjs-dist';

export default {
  props: ['data', 'pageObj', 'comments'],
  data() {
    return {
      minDate: new Date(),
      showLastDate: false,
      fileList:[
        {
          id:1,
          name:'测试文件名',
          status:'done',
          url: 'https://img.yzcdn.cn/vant/user-avatar.png',
          size: '100kb',
        },
        {
          id:2,
          name:'测试文件名2',
          status:'donew',
          url: 'https://img.yzcdn.cn/vant/user-avatar.png',
          size: '100kb',
        }
      ],
      informationlist:[
        {
          id:1,
          name:'测试信息名',
          conclusion:'通过'
        },
        {
          id:2,
          name:'测试名称',
          conclusion:'不通过'
        }
      ],
      isfie:false,
      imgSrc:'',
      ispic:false,
      // leaveData: {
      //   emplid: '',
      //   name_display: '',
      //   qh_backg_judge_description: '',
      //   business_unit_description: '',
      //   jobcode_description: '',
      //   qh_jobmanage_level_description: '',
      //   qh_major_level_description: '',
      //   deptid_description: '',
      //   location_description: '',
      //   company_description: '',
      // },
    };
  },
  watch: {
    data() {
      // 水印
      this.$nextTick(() => {
        const name = this.data.current_user;
        const now = new Date();
        const date = `${now.getFullYear()}/${
          now.getMonth() + 1
        }/${now.getDate()} ${now.getHours()}:${
          now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes()
        }`;
        watermark.set(date + name);
      });
    }
  },
  created() {
  },
  methods: {
    //解析base64
    base64ToBlob(base64Data, contentType) {
      contentType = contentType || '';
      var sliceSize = 1024;
      var byteCharacters = atob(base64Data);
      var byteArrays = [];
      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      console.log(byteArrays, 'byteArrays')
      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
     // 关闭文件
     closefie(){
      this.ispic = false
      this.imgSrc = ''
      this.isfie=false
      document.getElementById('pdfContainer').innerHTML = ''
    },
    //关闭图片
    closeImg(item) {
      this.ispic = false
      this.imgSrc = ''
      this.isfie=false
    },
    //下载图片
    downloads(item,e) {
      this.$toast.loading("加载中...");
      let path = this.$route.query.path || this.$route.query.pageId;
      console.log(path,'path')
      let options = {
        url: `/treasure/ehr/${path}/DoGetAttachment`,
        method: "POST",
        data: {
          emplid: this.data.header.emplid, // 员工编号
          action_dt_ss: this.data.header.action_dt_ss, // 提交时间
          effseq: this.data.header.effseq, // 生效序号
          attachFileRecName:'QH_HR_029_HD01', // 附件记录名称
          attachsysfilename: item.attachsysfilename // 系统唯一文件名称
        }
      };
      request(options)
        .then(({ data }) => {
          if (data.code == 200) {
              let src = data.data.data;
              console.log('是图片')
              if (!/base64,/.test(src)) {
                src = "data:image/jpeg;base64," + src;
              }
              this.imgSrc = src;
              this.ispic = true
              this.isfie = false
              this.$toast.clear();
          } else {
            this.toast = this.$toast("下载文件失败");
            this.$toast.clear();
          }
          
        })
        .catch((e) => {
          console.log(e);
          this.$toast.clear();
        });
    },
    // 正则匹配.后面的值
    getMatch(str) {
      const dotIndex = str.lastIndexOf('.');
      if (dotIndex === -1) {
        return '';
      }
      return str.slice(dotIndex + 1);
    },
  }
};
</script>
<style lang="scss" scoped>
.remarks{
  padding: 10px 0 10px 10px;
  color: rgba(0, 0, 0, 0.3);
}
.van-cell .van-cell__value {
  text-align: right;
  padding-right: 0.6rem;
}
.van-cell {
  border-bottom: 1px solid $border-color;
}
.base {
  border-bottom: none;
}
.van-cell__right-icon {
  // margin-left: -2.8rem;
  // float: right;
  position: absolute;
  right: 0.1rem;
}
.van-cell .van-cell__title {
  width: 4rem;
  // color:#000
}
.w100 .van-cell__title {
  width: 8rem;
}
.van-collapse-item__wrapper .van-collapse-item__content {
  color: rgba(0, 0, 0, 0.9);
}
.title {
  color: rgba(0, 0, 0, 0.3);
  // color: #000;
  font-size: 0.4rem;
  text-align: left;
  padding-left: 0.42667rem;
}
.desc {
  color: #ccc;
  padding-left: 25px;
  font-size: 0.35rem;
  text-align: left;
}

//下载文档
.fileList{
  width: 90%;
  margin: 0 auto;
  font-size: 14px;
  li{
    border: 1px solid #d8e0e8;
    border-radius: 5px;
    padding: 10px;
    margin-top: 10px;
    box-sizing: border-box;
    display: flex;
    div:nth-child(1){
      width: 90%;
      display: flex;
      img{
        width: 50px;
        height: 50px;
      }
      div{
        width: 80%;
        padding-left: 10px;
        box-sizing: border-box;
        p{
          margin-top: 5px;
          white-space: nowrap; /* 让文本不换行 */
          overflow: hidden; /* 隐藏溢出的文本 */
          text-overflow: ellipsis; /* 在溢出处显示省略号 */
        }
        p:nth-child(2){
          margin-top: 8px;
        }
      }
    }
    .downloads{
      width: 10%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
  }
  li:last-child{
    margin: 10px 0;
  }
}
//面试信息
.InterviewInformation{
  width: 90%;
  margin:10px auto;
  border: 1px solid #e3e8ee;
  border-radius: 5px;
  font-size: 14px;
  ul{
    li{
      display: flex;
      text-align: left;
      border-bottom: 1px solid #dfe3e9;
      span{
        width: 30%;
        padding: 10px;
        border-right: 1px solid #e3e8ee;
      }
      span:nth-child(2){
        text-align: center;
      }
      span:last-child{
        width: 40%;
        border-right:none;
      }
    }
    .titles{
      color: #677389;
      background: #f7f9fa;
    }
    li:last-child{
      border-bottom:0 none;
    }
  }
}
.tips{
  width: 90%;
  margin:10px auto;
  color: #626f85;
  font-size: 14px;
}
.view{
  width: 90%;
  margin:10px auto;
 
  
  p{
    background: #f7f9fa;
    padding: 10px;
    border-radius: 5px;
    box-sizing: border-box;
    font-size: 14px;
  }
}
.setpic{
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  padding: 5px 0;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  .guanbi{
    max-width: 98%;
    max-height: 100%;
    position: relative;
    overflow: auto;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .pic{
     width: 100%;
     height: 100%;
    }
    .guanbiimg{
      width: 30px;
      height: 30px;
      position: absolute;
      right: 10px;
      top: 15px;
    }
  }
  .fleguanbi{
    max-width: 90%;
    max-height: 50%;
    position: relative;
    // top: 50%;
    // left: 50%;
    // transform: translate(-50%, -50%);
    .guanbiimg {
      width: 30px;
      height: 30px;
      position: absolute;
      right: -20px;
      top: 10px;
      z-index: 2;
    }
  }
}
</style>